
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"34","viewBox":"0 0 34 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.286.714a4.164 4.164 0 013 3c.762 2.667.714 8.19.714 8.19s0 5.525-.714 8.191a4.164 4.164 0 01-3 3C27.666 23.81 17 23.81 17 23.81s-10.62 0-13.286-.715a4.164 4.164 0 01-3-3C0 17.43 0 11.905 0 11.905S0 6.38.714 3.762c.381-1.476 1.572-2.667 3-3.048C6.381 0 17 0 17 0s10.667 0 13.286.714zM13.619 6.81l8.857 5.095L13.62 17V6.81z","fill":"#000"}})])
          )
        }
      }
    